import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryImages: Record<string, string> = {
  romance: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romantic%20scene%20with%20soft%20pink%20and%20warm%20colors%2C%20aesthetic%20flat%20illustration%2C%20couple%20silhouette%2C%20minimal%20design%2C%20clean%20background%2C%20dreamy%20atmosphere&width=400&height=300&seq=cat-romance&orientation=landscape',
  fantasy: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20magic%20scene%2C%20floating%20crystals%20and%20spell%20effects%2C%20aesthetic%20flat%20illustration%2C%20purple%20and%20gold%20colors%2C%20minimal%20design%2C%20clean%20background&width=400&height=300&seq=cat-fantasy&orientation=landscape',
  action: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dynamic%20action%20scene%2C%20speed%20lines%20and%20motion%20effects%2C%20aesthetic%20flat%20illustration%2C%20red%20and%20orange%20colors%2C%20minimal%20design%2C%20clean%20background&width=400&height=300&seq=cat-action&orientation=landscape',
  mystery: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20noir%20scene%2C%20silhouette%20with%20magnifying%20glass%2C%20aesthetic%20flat%20illustration%2C%20dark%20blue%20and%20teal%20colors%2C%20minimal%20design%2C%20clean%20background&width=400&height=300&seq=cat-mystery&orientation=landscape',
  urban: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20modern%20city%20scene%2C%20neon%20lights%20and%20skyscrapers%2C%20aesthetic%20flat%20illustration%2C%20warm%20night%20colors%2C%20minimal%20design%2C%20clean%20background&width=400&height=300&seq=cat-urban&orientation=landscape',
  historical: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20ancient%20Korean%20palace%20scene%2C%20traditional%20architecture%2C%20aesthetic%20flat%20illustration%2C%20warm%20earth%20tones%2C%20minimal%20design%2C%20clean%20background&width=400&height=300&seq=cat-historical&orientation=landscape',
  comedy: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20playful%20comedy%20scene%2C%20bright%20and%20colorful%2C%20aesthetic%20flat%20illustration%2C%20yellow%20and%20green%20colors%2C%20minimal%20design%2C%20clean%20background&width=400&height=300&seq=cat-comedy&orientation=landscape',
  horror: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20spooky%20atmosphere%2C%20dark%20shadows%20and%20moonlight%2C%20aesthetic%20flat%20illustration%2C%20dark%20purple%20colors%2C%20minimal%20design%2C%20clean%20background&width=400&height=300&seq=cat-horror&orientation=landscape',
};

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            八大分类，发现你最爱的韩漫类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden aspect-[4/3] bg-background-200 cursor-pointer"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={`${cat.name} 韩漫分类`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
                    <i className={`${cat.icon} text-white text-sm`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-sm font-bold text-white">{cat.name}</h3>
                    <p className="text-xs text-white/70">{cat.count}部作品</p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}